<template>
  <div
    v-if="availableButtons.length > 0"
    class="nx-login-form__content"
  >
    <ds-heading
      size="500"
      class="text-xs-center"
    >
      {{ $t('message.login.alternativeLoginMethods.title') }}
    </ds-heading>
    <v-container
      fluid
      class="grid-list-md pa-0 overflow-hidden"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          v-for="loginMethod in availableButtons"
          :key="loginMethod.id"
          :class="layoutFlexSize"
          class="d-flex justify-center"
        >
          <component
            :is="loginMethod.component"
            v-on="$listeners"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { loginMethods } from '@/modules/authentication/config/login-methods';

export default {
  name: 'NxAuthAlternativeLoginMethodsDrawer',
  props: {
    currentLoginMethod: {
      type: String,
      required: true,
    },
  },
  computed: {
    availableButtons() {
      return loginMethods
        .filter(loginMethod => loginMethod.component)
        .filter(loginMethod => loginMethod.id !== this.currentLoginMethod)
        .filter(loginMethod => (typeof loginMethod.enabled === 'function' ? loginMethod.enabled() : true))
        .sort((loginMethodA, loginMethodB) => loginMethodA.drawerPosition - loginMethodB.drawerPosition);
    },
    layoutFlexSize() {
      const buttons = this.availableButtons.length;
      if (buttons <= 1) return 'xs12';
      if (buttons === 2 || buttons === 4) return 'xs6';
      return 'xs4';
    },
  },
};
</script>
